export default class AppStack {
	constructor() {
		this.items = {};
	}

	getItem(name) {
		return this.items[name];
	}

	setItem(name, state) {
		this.items[name] = state;
	}

	removeItem(name) {
		if (this.items[name] !== undefined) delete this.items[name];
	}

	clearAll(){
		this.items = {};
	}

}


// WEBPACK FOOTER //
// ./modules/distribution/services/app_stack.js